module.exports = __webpack_public_path__ + "static/img/p1-a-1.abe7c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-a-1.png
// module id = 0t+z
// module chunks = 0